(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
document.querySelector('[data-para-formularz]')?.addEventListener('submit', function (event) { event.preventDefault(); });
var T13 = {
        brakD:  __pewniaki_inline_cfg[0],
        parar:  __pewniaki_inline_cfg[1],
        model:  __pewniaki_inline_cfg[2],
        zwykly: __pewniaki_inline_cfg[3],
        poza2:  __pewniaki_inline_cfg[4],
        pozycja:__pewniaki_inline_cfg[5],
        brakM:  __pewniaki_inline_cfg[6],
        ok2:    __pewniaki_inline_cfg[7],
        ponad2: __pewniaki_inline_cfg[8],
        calosc: __pewniaki_inline_cfg[9],
        ostat:  __pewniaki_inline_cfg[10]
    };

(function () {
    var A = {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[11] + '/analizy/pary.json',
        wersja: __pewniaki_inline_cfg[12],
        lata:   '/assets/json/db/' + __pewniaki_inline_cfg[13] + '/lata/',
        pula:   JSON.parse(String(__pewniaki_inline_cfg[14])),
        q2:     JSON.parse(String(__pewniaki_inline_cfg[15])),
        domyslne: __pewniaki_inline_cfg[16]
    };
    var wybor = { a: JSON.parse(String(__pewniaki_inline_cfg[17])), b: JSON.parse(String(__pewniaki_inline_cfg[18])) }, ostatnie = null;
    var q = function (s) { return document.querySelector(s); };
    var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    var separator = __pewniaki_inline_cfg[19];
    var f1 = function (v) { return v == null ? '—' : (Math.round(v * 10) / 10).toString().replace('.', separator); };
    var f2 = function (v) { return v == null ? '—' : (v > 0 ? '+' : '') + (Math.round(v * 100) / 100).toString().replace('.', separator); };
    var parOgolem = function (dane) { var m = (dane && dane.pula) || A.pula; return m * (m - 1) / 2; };
    var kluczPary = function () { return Math.min(wybor.a, wybor.b) + '-' + Math.max(wybor.a, wybor.b); };
    // e_pary z okna; gdy go nie ma (zakres lat) — N * q2 z modelu; bez modelu niedostepne, nie zero
    var oczekiwane = function (okno, dane) {
        if (okno.e_pary != null) return okno.e_pary;
        var q2 = dane && dane.model && dane.model.q2 != null ? dane.model.q2 : A.q2;
        return q2 != null && okno.losowan ? okno.losowan * q2 : null;
    };
    var policz = function (okno, dane) {
        if (!okno || !okno.pary) return null;
        var c = okno.pary[kluczPary()] || 0, e = oczekiwane(okno, dane), lepsze = 0;
        Object.keys(okno.pary).forEach(function (kl) { if (okno.pary[kl] > c) lepsze++; });
        return { N: okno.losowan || 0, ile: c, e: e, odch: e != null && e > 0 ? (c - e) / Math.sqrt(e) : null, pozycja: lepsze + 1 };
    };

    A.sumujLata = function (roczniki) {
        var pary = {}, N = 0;
        roczniki.forEach(function (r) {
            N += r.losowan || 0;
            Object.keys(r.pary || {}).forEach(function (kl) { pary[kl] = (pary[kl] || 0) + r.pary[kl]; });
        });
        return { losowan: N, pary: pary, e_pary: null };
    };

    A.wnioski = function (okno, klucz, dane) {
        if (!okno) return [__pewniaki_inline_cfg[20]];
        var w = policz(okno, dane), p = [];
        if (!w) return [__pewniaki_inline_cfg[21]];
        p.push(T13.parar.replace('%1', wybor.a).replace('%2', wybor.b).replace('%3', tys(w.ile)).replace('%4', tys(w.N)));
        if (w.odch != null) p.push(T13.model.replace('%1', f1(w.e)).replace('%2', f2(w.odch))
            + (Math.abs(w.odch) < 2 ? T13.zwykly : T13.poza2.replace('%1', tys(parOgolem(dane)))));
        p.push(T13.pozycja.replace('%1', w.pozycja).replace('%2', tys(parOgolem(dane))));
        return p;
    };

    A.render = function (okno, klucz, dane, zakres) {
        ostatnie = { okno: okno, klucz: klucz, dane: dane, zakres: zakres };
        var karta = q('[data-para-wynik]');
        var kule = document.querySelectorAll('[data-para-kule] .kula');
        if (kule.length === 2) { kule[0].textContent = wybor.a; kule[1].textContent = wybor.b; }
        var w = policz(okno, dane);
        if (!w) { if (karta) karta.hidden = true; }
        else {
            karta.hidden = false;
            q('[data-para-n]').textContent = tys(w.N);
            q('[data-para-ile]').textContent = tys(w.ile);
            q('[data-para-proc]').textContent = w.N ? f1(w.ile * 100 / w.N) : '—';
            q('[data-para-e]').textContent = f1(w.e);
            q('[data-para-odch]').textContent = f2(w.odch);
            q('[data-para-pozycja]').textContent = w.pozycja;
            q('[data-para-zdanie]').textContent = w.odch == null
                ? T13.brakM
                : (Math.abs(w.odch) < 2
                    ? T13.ok2
                    : T13.ponad2.replace('%1', tys(parOgolem(dane))));
        }
        // tabela okien — niezalezna od wybranego zakresu, zalezna od wybranej pary
        var okna = (dane && dane.okna) || {}, lista = (dane && dane.okna_lista) || Object.keys(okna), kl = kluczPary(), wiersze = [];
        lista.forEach(function (ko) {
            var o = okna[String(ko)];
            if (!o || o.powod || !o.pary) return;
            var c = o.pary[kl] || 0, e = oczekiwane(o, dane), odch = e != null && e > 0 ? (c - e) / Math.sqrt(e) : null;
            wiersze.push('<tr><td>' + (String(ko) === 'all' ? T13.calosc : T13.ostat.replace('%1', ko)) + '</td><td class="liczbowa">' + tys(o.losowan || 0)
                + '</td><td class="liczbowa">' + tys(c) + '</td><td class="liczbowa">' + f1(e) + '</td><td class="liczbowa">' + f2(odch) + '</td></tr>');
        });
        var tbody = q('[data-para-okna] tbody');
        if (tbody && wiersze.length) tbody.innerHTML = wiersze.join('');
    };

    window.PEWNIAKI_ANALIZA = A;

    // formularz: stan w adresie ?a=&b=, przeliczenie bez przeladowania
    var selA = q('#para-a'), selB = q('#para-b'), blad = q('[data-para-blad]');
    if (!selA || !selB) return;
    var par = new URLSearchParams(location.search), ua = parseInt(par.get('a'), 10), ub = parseInt(par.get('b'), 10);
    if (ua >= 1 && ua <= A.pula && ub >= 1 && ub <= A.pula && ua !== ub) { wybor = { a: ua, b: ub }; selA.value = ua; selB.value = ub; }
    var odswiezWnioski = function () {
        var lista = q('[data-analiza-wnioski] ul, [data-analiza-wnioski] ol');
        if (!lista || !ostatnie) return;
        lista.innerHTML = '';
        A.wnioski(ostatnie.okno, ostatnie.klucz, ostatnie.dane, ostatnie.zakres).forEach(function (t) {
            var li = document.createElement('li'); li.textContent = t; lista.appendChild(li);
        });
    };
    var naZmiane = function () {
        var a = parseInt(selA.value, 10), b = parseInt(selB.value, 10);
        if (!Number.isInteger(a) || !Number.isInteger(b) || a < 1 || b < 1 || a > A.pula || b > A.pula || a === b) {
            if (blad) blad.hidden = false;
            var previous = q('[data-para-wynik]');if (previous) previous.hidden = true;
            return;
        }
        if (blad) blad.hidden = true;
        wybor = { a: a, b: b };
        var u = new URL(location.href); u.searchParams.set('a', a); u.searchParams.set('b', b);
        history.replaceState(null, '', u);
        if (ostatnie) { A.render(ostatnie.okno, ostatnie.klucz, ostatnie.dane, ostatnie.zakres); odswiezWnioski(); return; }
        // przed pierwsza zmiana zakresu nie mamy danych z analiza.js — bierzemy okno domyslne z pliku
        fetch(A.plik+'?v='+encodeURIComponent(A.wersja||'')).then(function (r) { if (!r.ok) throw new Error('HTTP');return r.json(); }).then(function (d) {
            var o = d.okna && d.okna[A.domyslne];
            A.render(o && !o.powod ? o : null, A.domyslne, d);
            odswiezWnioski();
        }).catch(function () {
            var previous = q('[data-para-wynik]');if (previous) previous.hidden = true;
            if (blad) {blad.hidden = false;blad.textContent = __pewniaki_inline_cfg[22];}
        });
    };
    selA.addEventListener('change', naZmiane);
    selB.addEventListener('change', naZmiane);
    var btn = q('[data-para-sprawdz]');
    if (btn) btn.addEventListener('click', naZmiane);
    if (wybor.a !== JSON.parse(String(__pewniaki_inline_cfg[23])) || wybor.b !== JSON.parse(String(__pewniaki_inline_cfg[24]))) naZmiane();
})();
})();
